import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { serviceImages } from '../../constants/images';
import Footer from '../Footer';
const ApplicationDevelopment = () => {
  useEffect(() => {
    document.title = 'Application Development - Global Excellence';
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: '💻',
      title: 'Custom Software Development',
      description: 'Tailored solutions built to your specific business needs'
    },
    {
      icon: '📱',
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile applications'
    },
    {
      icon: '🌐',
      title: 'Web Application Development',
      description: 'Modern, responsive web applications'
    },
    {
      icon: '🔄',
      title: 'API Development',
      description: 'Robust and scalable API solutions'
    },
    {
      icon: '🔒',
      title: 'Security Implementation',
      description: 'Enterprise-grade security features'
    },
    {
      icon: '📊',
      title: 'Performance Optimization',
      description: 'High-performance, scalable applications'
    }
  ];

  const processSteps = [
    {
      number: '01',
      title: 'Requirement Analysis',
      description: 'Gather and analyze project requirements'
    },
    {
      number: '02',
      title: 'Design & Planning',
      description: 'Create detailed technical specifications'
    },
    {
      number: '03',
      title: 'Development',
      description: 'Implement features with best practices'
    },
    {
      number: '04',
      title: 'Testing',
      description: 'Comprehensive quality assurance'
    },
    {
      number: '05',
      title: 'Deployment',
      description: 'Smooth deployment to production'
    },
    {
      number: '06',
      title: 'Maintenance',
      description: 'Ongoing support and updates'
    }
  ];

  const technologies = [
    { icon: '⚛️', name: 'React' },
    { icon: '🅰️', name: 'Angular' },
    { icon: '🟢', name: 'Node.js' },
    { icon: '🐍', name: 'Python' },
    { icon: '☕', name: 'Java' },
    { icon: '☁️', name: 'AWS' },
    { icon: '🐳', name: 'Docker' },
    { icon: '⚓', name: 'Kubernetes' }
  ];
  return (
    <>
      <div className="service-component-wrapper">
        {/* Hero Section */}
        <section className="service-component-hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="service-hero-content"
          >
            <h1 className="service-hero-title">Application Development</h1>
            <p className="service-hero-subtitle">
              Building innovative software solutions for your business needs
            </p>
          </motion.div>
        </section>

        {/* Overview Section */}
        <section className="service-overview">
          <div className="service-overview-content">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="service-overview-text"
            >
              <h2>Custom Software Solutions</h2>
              <p>
                We develop high-quality, scalable applications that help businesses
                streamline operations and enhance productivity. Our team of expert
                developers uses the latest technologies and best practices to deliver
                robust solutions tailored to your specific requirements.
              </p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="service-overview-image"
            >
              <img src={serviceImages.applicationDev} alt="Application Development" />
            </motion.div>
          </div>
        </section>

        {/* Features Section */}
        <section className="service-features">
          <h2>Our Development Services</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="feature-card"
              >
                <span className="feature-icon">{feature.icon}</span>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Process Section */}
        <section className="service-process">
          <h2>Our Development Process</h2>
          <div className="process-grid">
            {processSteps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="process-card"
              >
                <span className="process-number">{step.number}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* Technologies Section */}
        <section className="service-technologies">
          <h2>Technologies We Use</h2>
          <div className="tech-grid">
            {technologies.map((tech, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="tech-item"
              >
                <span className="tech-icon">{tech.icon}</span>
                <span className="tech-name">{tech.name}</span>
              </motion.div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="service-cta">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="cta-content"
          >
            <h2 style={{color: 'white'}}>Ready to Build Your Application?</h2>
            <p style={{color: 'white'}}>Let's discuss how we can help you achieve your development goals</p>
            <div className="cta-buttons">
              <Link to="/contactus" className="cta-button primary">
                Get Started
              </Link>
              <Link to="/services" className="cta-button secondary">
                View All Services
              </Link>
            </div>
          </motion.div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default ApplicationDevelopment; 